import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.permissions.create.title',
    defaultMessage: 'New Permission',
  },
});

export default function AdminUsersCreatePage() {
  const { formatMessage } = useIntl();
  return (
    <AdminManagement.Layout
      maxContentWidth="md"
      title={formatMessage(messages.title)}
    >
      <BigCircle />
      <AdminManagement.Permissions.Create />
    </AdminManagement.Layout>
  );
}
